import {
    Card,
    CardActions,
    CircularProgress,
    Container,
    CssBaseline,
    Grid,
    TextField,
} from '@material-ui/core';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import Scrollbar from 'react-scrollbars-custom';
import AppBarComponent from '../../layout/AppBar';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import { useStyles } from '../../styles/useStyles';
import LocationDataService from '../../../services/LocationService';
import { CardContent, CardHeader } from '@mui/material';
import 'react-month-picker/css/month-picker.css';
import { API_URL } from '../../../utils/setApiUrl.js';
import useCheckPermission from '../../../utils/permissions/useCheckPermissions';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getAppTimezone } from '../../../utils/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Form76(props) {
    const isSuper = useCheckPermission('super');
    const { t, i18n } = useTranslation();
    const locData = JSON.parse(localStorage.getItem('loc'));

    const classes = useStyles();

    const [locations, setLocations] = useState([]);

    useEffect(() => {
        retrieveLocations();
    }, []);

    const retrieveLocations = () => {
        LocationDataService.getAll()
            .then(response => {
                setLocations(response.data);
                console.log(response.data);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const [locationValue, setLocationValue] = React.useState('');
    const [locationInputValue, setLocationInputValue] = React.useState('');

    // Month arrays for different languages
    const bgMonths = [
        { label: 'Януари', value: 1 },
        { label: 'Февруари', value: 2 },
        { label: 'Март', value: 3 },
        { label: 'Април', value: 4 },
        { label: 'Май', value: 5 },
        { label: 'Юни', value: 6 },
        { label: 'Юли', value: 7 },
        { label: 'Август', value: 8 },
        { label: 'Септември', value: 9 },
        { label: 'Октомври', value: 10 },
        { label: 'Ноември', value: 11 },
        { label: 'Декември', value: 12 },
    ];
    const enMonths = [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 },
    ];
    const esMonths = [
        { label: 'Enero', value: 1 },
        { label: 'Febrero', value: 2 },
        { label: 'Marzo', value: 3 },
        { label: 'Abril', value: 4 },
        { label: 'Mayo', value: 5 },
        { label: 'Junio', value: 6 },
        { label: 'Julio', value: 7 },
        { label: 'Agosto', value: 8 },
        { label: 'Septiembre', value: 9 },
        { label: 'Octubre', value: 10 },
        { label: 'Noviembre', value: 11 },
        { label: 'Diciembre', value: 12 },
    ];
    // Select months based on current language
    const [months, setMonths] = useState(
        i18n.language === 'bg'
            ? bgMonths
            : i18n.language === 'es'
            ? esMonths
            : enMonths
    );

    // Get the current month and year (in configured app timezone)
    const _now = dayjs().tz(getAppTimezone());
    const currentMonth = _now.month() + 1; // dayjs month() is 0-11
    const currentYear = _now.year();

    // Set the default selected month and year
    const [selectedMonth, setSelectedMonth] = useState(
        months.find(month => month.value === currentMonth)
    );
    const [selectedYear, setSelectedYear] = useState({
        label: currentYear.toString(),
        value: currentYear,
    });

    // Update months when language changes
    useEffect(() => {
        let newMonths;
        if (i18n.language === 'bg') {
            newMonths = bgMonths;
        } else if (i18n.language === 'es') {
            newMonths = esMonths;
        } else {
            newMonths = enMonths;
        }

        setMonths(newMonths);

        // Update selected month to maintain the same value with new language label
        if (selectedMonth) {
            const newSelectedMonth = newMonths.find(
                month => month.value === selectedMonth.value
            );
            if (newSelectedMonth) {
                setSelectedMonth(newSelectedMonth);
            }
        }
    }, [i18n.language]);

    // Month Picker State
    const years = [
        { label: '2023', value: 2023 },
        { label: '2024', value: 2024 },
        { label: '2025', value: 2025 },
        { label: '2026', value: 2026 },
        { label: '2027', value: 2027 },
        { label: '2028', value: 2028 },
        { label: '2029', value: 2029 },
        { label: '2030', value: 2030 },
        { label: '2031', value: 2031 },
        { label: '2032', value: 2032 },
        { label: '2033', value: 2033 },
        { label: '2034', value: 2034 },
    ];

    const [isGenerating, setIsGenerating] = useState(false);

    const handleMonthChange = (event, value) => {
        setSelectedMonth(value);
    };

    const handleYearChange = (event, value) => {
        setSelectedYear(value);
    };

    const handleGenerateClick = () => {
        if (selectedMonth) {
            generateForm76(selectedMonth.value);
        }
    };

    const fetchWithTimeout = (url, options, timeout = 300000) => {
        return new Promise((resolve, reject) => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                controller.abort();
                reject(new Error('Request timeout'));
            }, timeout);

            fetch(url, { ...options, signal: controller.signal })
                .then(response => {
                    clearTimeout(timeoutId);
                    resolve(response);
                })
                .catch(error => {
                    clearTimeout(timeoutId);
                    reject(error);
                });
        });
    };

    const generateForm76 = async () => {
        setIsGenerating(true); // Start loading/generating

        try {
            const currentYear = dayjs().tz(getAppTimezone()).year();
            const formattedMonth = String(selectedMonth.value).padStart(2, '0');

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                const response = await fetchWithTimeout(
                    `${API_URL}/form76Full/loc/${joinedValues}`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            month: formattedMonth,
                            year: selectedYear.value,
                        }),
                    },
                    300000 // 5 minutes
                );

                if (response.ok) {
                    const blob = await response.blob();

                    // Create a temporary download link
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = `Form76_${selectedMonth.value}.xlsx`;

                    // Programmatically trigger the download
                    downloadLink.click();

                    console.log(
                        'Report generation and file download were successful!'
                    );
                } else {
                    throw new Error('Report generation failed');
                }
            } else if (locData.id === 'all') {
                const joinedValues = locData.join(',');
                const response = await fetchWithTimeout(
                    `${API_URL}/form76/all`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            month: formattedMonth,
                            year: selectedYear,
                        }),
                    },
                    300000
                );

                if (response.ok) {
                    const blob = await response.blob();

                    // Create a temporary download link
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = `Form76_${selectedMonth.value}.xlsx`;

                    // Programmatically trigger the download
                    downloadLink.click();

                    console.log(
                        'Report generation and file download were successful!'
                    );
                } else {
                    throw new Error('Report generation failed');
                }
            }
        } catch (error) {
            console.error('An error occurred:', error.message);
        } finally {
            setIsGenerating(false); // Stop loading/generating after download starts or fails
        }
    };

    const handleGenerateFullClick = () => {
        if (selectedMonth) {
            generateForm76Full(selectedMonth.value);
        }
    };

    const generateForm76Full = async () => {
        setIsGenerating(true); // Start loading/generating

        try {
            const currentYear = dayjs().tz(getAppTimezone()).year();
            const formattedMonth = String(selectedMonth.value).padStart(2, '0');

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                const response = await fetchWithTimeout(
                    `${API_URL}/form76Full/loc/${joinedValues}`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            month: formattedMonth,
                            year: selectedYear.value,
                        }),
                    },
                    300000
                );

                if (response.ok) {
                    const blob = await response.blob();

                    // Create a temporary download link
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = `Form76_${selectedMonth.value}.xlsx`;

                    // Programmatically trigger the download
                    downloadLink.click();

                    console.log(
                        'Report generation and file download were successful!'
                    );
                } else {
                    throw new Error('Report generation failed');
                }
            } else if (locData.id === 'all') {
                const response = await fetchWithTimeout(
                    `${API_URL}/form76Full/all`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            month: formattedMonth,
                            year: selectedYear.value,
                        }),
                    },
                    300000
                );

                if (response.ok) {
                    const blob = await response.blob();

                    // Create a temporary download link
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = `Form76_${selectedMonth.value}.xlsx`;

                    // Programmatically trigger the download
                    downloadLink.click();

                    console.log(
                        'Report generation and file download were successful!'
                    );
                } else {
                    throw new Error('Report generation failed');
                }
            }
        } catch (error) {
            console.error('An error occurred:', error.message);
        } finally {
            setIsGenerating(false); // Stop loading/generating after download starts or fails
        }
    };

    const currentHost = window.location.hostname;
    const currentPort = window.location.port;

    // Check if the current host and port match the criteria
    const shouldRender = currentHost === 'billa.biodit.bg' || 'localhost';

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBarComponent />
            <main className={classes.content}>
                <Scrollbar
                    id="RSC-Example"
                    style={{ width: '100%', height: '100%' }}
                >
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth="lg" className={classes.container}>
                        <Grid container spacing={3}>
                            {/*<Grid item xs={4}>*/}
                            {/*    <Card*/}
                            {/*        className={clsx(classes.card)}*/}
                            {/*        elevation={1}*/}
                            {/*    >*/}
                            {/*        <CardHeader*/}
                            {/*            title="Форма 76"*/}
                            {/*            subheader="без специални събития"*/}
                            {/*            sx={{ pb: 0 }}*/}
                            {/*        />*/}
                            {/*        <CardContent sx={{ pt: 0 }}>*/}
                            {/*            <Autocomplete*/}
                            {/*                options={months}*/}
                            {/*                getOptionLabel={(option) =>*/}
                            {/*                    option.label*/}
                            {/*                }*/}
                            {/*                value={selectedMonth}*/}
                            {/*                onChange={handleMonthChange}*/}
                            {/*                renderInput={(params) => (*/}
                            {/*                    <TextField*/}
                            {/*                        {...params}*/}
                            {/*                        label="Изберете Месец"*/}
                            {/*                    />*/}
                            {/*                )}*/}
                            {/*            />*/}

                            {/*<Autocomplete*/}
                            {/*    value={locations.number}*/}
                            {/*    onChange={(*/}
                            {/*        event,*/}
                            {/*        newLocationValue*/}
                            {/*    ) => {*/}
                            {/*        setLocationValue(*/}
                            {/*            newLocationValue*/}
                            {/*        );*/}
                            {/*    }}*/}
                            {/*    inputValue={locationInputValue}*/}
                            {/*    onInputChange={(*/}
                            {/*        event,*/}
                            {/*        locationInputValue*/}
                            {/*    ) => {*/}
                            {/*        setLocationInputValue(*/}
                            {/*            locationInputValue*/}
                            {/*        );*/}
                            {/*    }}*/}
                            {/*    id="auto-select location"*/}
                            {/*    getOptionLabel={(locations) =>*/}
                            {/*        locations.name*/}
                            {/*    }*/}
                            {/*    options={locations}*/}
                            {/*    renderInput={(params) => (*/}
                            {/*        <TextField*/}
                            {/*            {...params}*/}
                            {/*            label="Изберете локация"*/}
                            {/*            variant="outlined"*/}
                            {/*            size="small"*/}
                            {/*        />*/}
                            {/*    )}*/}
                            {/*/>*/}
                            {/*        </CardContent>*/}
                            {/*        <CardActions>*/}
                            {/*            <Button*/}
                            {/*                type="submit"*/}
                            {/*                variant="contained"*/}
                            {/*                color="primary"*/}
                            {/*                className={classes.button}*/}
                            {/*                onClick={handleGenerateClick}*/}
                            {/*                disabled={isGenerating} // Disable the button when generating*/}
                            {/*            >*/}
                            {/*                {isGenerating ? (*/}
                            {/*                    <CircularProgress size={24} />*/}
                            {/*                ) : (*/}
                            {/*                    'Генерирай'*/}
                            {/*                )}*/}
                            {/*            </Button>*/}
                            {/*        </CardActions>*/}
                            {/*    </Card>*/}
                            {/*</Grid>*/}
                            <Grid item xs={12} lg={3}>
                                {/*<Form76Table />*/}
                                {shouldRender && (
                                    <Card
                                        className={clsx(classes.card)}
                                        elevation={1}
                                    >
                                        <CardHeader
                                            title={t(
                                                'navbar.references.form76'
                                            )}
                                            sx={{ pb: 0 }}
                                        />{' '}
                                        <CardContent sx={{ pt: 0 }}>
                                            {' '}
                                            <Autocomplete
                                                options={months}
                                                getOptionLabel={option =>
                                                    option.label
                                                }
                                                value={selectedMonth}
                                                onChange={handleMonthChange}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label={
                                                            i18n.language ===
                                                            'bg'
                                                                ? 'Изберете Месец'
                                                                : i18n.language ===
                                                                  'es'
                                                                ? 'Seleccione Mes'
                                                                : 'Select Month'
                                                        }
                                                    />
                                                )}
                                            />{' '}
                                            <Autocomplete
                                                options={years}
                                                getOptionLabel={option =>
                                                    option.label
                                                }
                                                value={selectedYear}
                                                onChange={handleYearChange}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label={
                                                            i18n.language ===
                                                            'bg'
                                                                ? 'Изберете Година'
                                                                : i18n.language ===
                                                                  'es'
                                                                ? 'Seleccione Año'
                                                                : 'Select Year'
                                                        }
                                                    />
                                                )}
                                            />
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className={classes.button}
                                                onClick={
                                                    handleGenerateFullClick
                                                }
                                                disabled={isGenerating} // Disable the button when generating
                                            >
                                                {isGenerating ? (
                                                    <CircularProgress
                                                        size={24}
                                                    />
                                                ) : i18n.language === 'bg' ? (
                                                    'Генерирай'
                                                ) : i18n.language === 'es' ? (
                                                    'Generar'
                                                ) : (
                                                    'Generate'
                                                )}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                )}
                            </Grid>
                        </Grid>
                    </Container>
                </Scrollbar>
            </main>
        </div>
    );
}

// export default connect(
//     mapStateToProps,
//     { logoutUser }
// )(Dashboard)
